import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { toastr } from 'react-redux-toastr';
import FooterWrapper from './FooterWrapper';
import './Footer.scss';

const Footer = () => {
  const [footerData, setFooterData] = useState<any>(null);
  const [headOfficeData, setHeadOfficeData] = useState<any>(null);

  useEffect(() => {
    const fetchFooterData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/footer?populate[0]=logo&populate[1]=appPromotion.item&populate[2]=appPromotion.item.icon&populate[3]=contactUs&populate[4]=contactUs.contactItem&populate[5]=menuBlock&populate[6]=menuBlock.navItem&populate[7]=menuBlock.navItem.icon&populate[8]=socialLinks&populate[9]=socialLinks.icon`
        );
        setFooterData(response?.data?.data);
      } catch (error) {
        toastr.error('Failed to fetch footer data', '');
      }
    };
    fetchFooterData();

    const fetchHeadOfficeData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/head-office?populate=*`
        );
        setHeadOfficeData(response?.data?.data);
      } catch (error) {
        toastr.error('Failed to fetch head office data', '');
      }
    };
    fetchHeadOfficeData();
  }, []);

  return <FooterWrapper data={footerData} headOfficeData={headOfficeData} />;
};

export default Footer;
